import { OrderSets, OrderStatus } from '../types';

export const ORDER_STATUSES = {
  ACCEPTED: 'Accepted',
  CLIENT_REVIEW: 'ClientReview',
  NEW: 'New',
  COMPLETE: 'Complete',
  CANCEL_PENDING: 'CancelPending',
  CANCELLED: 'Cancelled',
} as const;

export const ORDER_SETS = {
  all: 'allOrders',
  active: 'activeOrders',
  completed: 'completedOrders',
  cancelled: 'cancelledOrders',
} as const;

export const ORDER_SET_TO_STATUSES: {
  [key in OrderSets]: OrderStatus[];
} = {
  [ORDER_SETS.all]: [
    ORDER_STATUSES.NEW,
    ORDER_STATUSES.CLIENT_REVIEW,
    ORDER_STATUSES.ACCEPTED,
    ORDER_STATUSES.COMPLETE,
    ORDER_STATUSES.CANCELLED,
    ORDER_STATUSES.CANCEL_PENDING,
  ],
  [ORDER_SETS.active]: [
    ORDER_STATUSES.NEW,
    ORDER_STATUSES.CLIENT_REVIEW,
    ORDER_STATUSES.ACCEPTED,
  ],
  [ORDER_SETS.completed]: [ORDER_STATUSES.COMPLETE],
  [ORDER_SETS.cancelled]: [
    ORDER_STATUSES.CANCELLED,
    ORDER_STATUSES.CANCEL_PENDING,
  ],
};
